/** @jsxImportSource theme-ui */
import { Title } from "@bottlebooks/gatsby-theme-base/src";
import { Plural } from "@lingui/macro";
import React from "react";

export default function ProductsPageTitle({ totalCount, count, ...rest }) {
  if (count === totalCount) {
    return (
      <Title {...rest}>
        <Plural
          value={totalCount}
          one={
            <React.Fragment>
              Showing you <Em>#</Em> product
            </React.Fragment>
          }
          other={
            <React.Fragment>
              Showing you <Em>#</Em> products
            </React.Fragment>
          }
        />
      </Title>
    );
  }

  return (
    <Title {...rest}>
      <Plural
        value={totalCount}
        one={
          <React.Fragment>
            Showing you <Em>{count}</Em> of <Em>#</Em> product
          </React.Fragment>
        }
        other={
          <React.Fragment>
            Showing you <Em>{count}</Em> of <Em>#</Em> products
          </React.Fragment>
        }
      />
    </Title>
  );
}

export function Em({ children, ...rest }) {
  return (
    <em sx={{ color: "primary", fontStyle: "normal" }} {...rest}>
      {children}
    </em>
  );
}
